<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Tìm kiếm">
          <div slot="custombtn">
            <button id="popover-config-search" class="btn btn-box-tool">
              <i aria-hidden="true" class="fa fa-cog"></i>
            </button>
            <b-popover :show.sync="showConfigSearch" target="popover-config-search" title="Cấu hình hiển thị" triggers="hover">
              <b-table :fields="configFields" :items="configSearchItems" responsive>
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumnSearchForm($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <div v-show="isShowSearch('init_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày khởi tạo</label>
              <date-picker v-model="filterData.init_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('confirmed_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày chốt đơn</label>
              <date-picker v-model="filterData.confirmed_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('data_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày phát sinh doanh số</label>
              <date-picker v-model="filterData.data_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('charge_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày tính phí</label>
              <date-picker v-model="filterData.charge_date" range valueType="format" type="month" lang="vi"></date-picker>
            </div>
            <div v-show="isShowSearch('pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhân viên chăm sóc</label>
              <multiselect id="ajax" v-model="filterData.pics" :clear-on-select="false"
                           :close-on-select="false"
                           :disabled="disablePic" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingUser" :max-height="600" :multiple="true"
                           :options="groupUser" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="users" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm người dùng" track-by="code">
              </multiselect>
            </div>

            <div v-show="isShowSearch('products')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Sản phẩm</label>
              <multiselect id="ajax" v-model="filterData.products" :clear-on-select="false"
                           :close-on-select="false" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingProduct" :max-height="600" :multiple="true"
                           :options="groupProduct" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="products" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm sản phẩm" track-by="code">
              </multiselect>
            </div>

            <div v-show="isShowSearch('status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái đơn hàng</label>
              <div class="d-flex">
                <multiselect v-model="filterData.status" :close-on-select="true" :limit="1" :multiple="true"
                             :options="statusList"
                             label="text"
                             placeholder="Vui lòng chọn"
                             track-by="value" @remove="onRemoveStatus($event, filterData.status)"
                             @select="onSelectStatus($event, filterData.status)"></multiselect>
                <multiselect v-model="filterData.statusDetail" :close-on-select="true" :limit="1" :multiple="true"
                             :options="statusDetailList" label="text" placeholder="Vui lòng chọn"
                             track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('data_source')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nguồn đơn</label>
              <div class="d-flex">
                <multiselect v-model="filterData.data_source" :close-on-select="true" :limit="1"
                             :multiple="true" :options="data_source"
                             label="text"
                             placeholder="Vui lòng chọn"
                             track-by="value" @remove="onRemoveSource($event, filterData.status)"
                             @select="onSelectSource($event, filterData.status)"></multiselect>
                <multiselect v-model="filterData.data_channel" :close-on-select="true" :limit="1"
                             :multiple="true" :options="data_channel"
                             label="text" placeholder="Vui lòng chọn" track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('debt_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái nợ</label>
              <multiselect v-model="filterData.debt_status" :close-on-select="true" :multiple="false"
                           :options="debt_status_list"
                           label="text" placeholder="Vui lòng chọn" track-by="value"></multiselect>
            </div>

          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center">
              <b-button variant="success" @click="search">
                <span aria-hidden="true" class="glyphicon glyphicon-search"></span>Tìm kiếm
              </b-button>
            </div>
          </div>
        </Box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Báo cáo định kỳ">
          <div slot="custombtn">
            <button id="popover-config-table" class="btn btn-box-tool">
              <i aria-hidden="true" class="fa fa-cog"></i>
            </button>
            <b-popover :show.sync="showConfigTable" target="popover-config-table" title="Cấu hình hiển thị"
                       triggers="hover">
              <b-table :fields="configFields" :items="configItems" responsive>
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumn($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <b-table ref="selectableTable" :busy="loading" :fields="fields" :items="items" :select-mode="'multi'"
                     bordered hover outlined responsive
                     selectable
                     show-empty

                     @row-selected="onRowSelected"
            >
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>
              <template v-slot:cell(total_debt)="data">
                {{ data.item.total_debt | format_currency }}
              </template>
              <template v-slot:cell(paid_amount)="data">
                <div class="d-flex align-items-center font-weight-bold text-red">
                  {{ (data.item.total_debt - data.item.remaining_debt) | format_currency }}
                  <i v-if="data.index === 1" class="fa fa-star ml-1 text-yellow"></i>
                  <i v-if="data.index === 2" class="fa fa-star ml-1 text-blue"></i>
                </div>
              </template>
              <template v-slot:cell(paid_amount_percent)="data">
                {{ (data.item.total_debt === 0 ? 0 : ((data.item.total_debt - data.item.remaining_debt) / data.item.total_debt * 100)).toFixed(2) + '%' }}
              </template>
              <template v-slot:cell(remaining_debt)="data">
                {{ data.item.remaining_debt | format_currency }}
              </template>
              <template v-slot:cell(waiting_approved_remaining_debt)="data">
                {{ data.item.waiting_approved_remaining_debt | format_currency }}
              </template>
              <template v-slot:cell(total_price)="data">
                {{ data.item.total_price | format_currency }}
              </template>

              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>

              <template v-slot:cell(stt)="data">
                {{ data.item.id }}
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :per-page="pageSize"
              :total-rows="totalRow"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </Box>

      </div>
    </section>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {debounce} from 'lodash'
import UserApi from '../../api/user'
import Utils from '../../common/utils'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {mapActions, mapGetters} from 'vuex'
import Box from '../../components/Box'
import ReportAPI from '../../api/report'
import DataStatusAPI from '../../api/dataStatus'
import DataSubStatusAPI from '../../api/dataSubStatus'
import DataSourceAPI from '../../api/dataSource'
import DataChannelAPI from '../../api/dataChannel'
import {
  DEBT_STATUS_LIST,
  LOCAL_STORAGE_KEY,
  PERMISSION_KEY,
  MAX_PRODUCT_NUMBER,
  MAX_SALE_USER_NUMBER
} from '../../common/constant'
import ProductApi from '../../api/product'

export default {
  name: 'ReportAnnualRevenue',
  components: {
    Box,
    DatePicker,
    Multiselect,
  },
  data () {
    return {
      company: null,
      checkAll: false,
      filterData: {
        init_date: [null, null],
        confirmed_date: [null, null],
        data_date: [null, null],
        charge_date: [null, null],
        status: [],
        statusDetail: [],
        data_source: [],
        data_channel: [],
        phone: '',
        customer_name: '',
        debt_status: null,
        pics: [],
        products: []
      },
      bulkUpdateData: {
        status: [],
        statusDetail: [],
      },
      saleData: {
        pics: []
      },
      statusList: [],
      statusDetailList: [],
      data_source: [],
      data_channel: [],
      debt_status_list: DEBT_STATUS_LIST,
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      fields: [],
      originFields: [
        {
          key: 'pic',
          label: 'Nhân viên chăm sóc',
          show: true
        }, {
          key: 'total_order',
          label: 'Lượng hợp đồng duy trì',
          show: true
        }, {
          key: 'total_debt',
          label: 'Lượng công nợ cần thu',
          show: true
        }, {
          key: 'paid_amount',
          label: 'Thực thu',
          show: true
        }, {
          key: 'paid_amount_percent',
          label: '% Thực thu',
          show: true
        }, {
          key: 'remaining_debt',
          label: 'Công nợ cộng dồn',
          show: true
        }, {
          key: 'waiting_approved_remaining_debt',
          label: 'Công nợ KT chưa duyệt cộng dồn',
          show: true
        }, {
          key: 'total_price',
          label: 'Đơn giá',
          show: true
        }
      ],
      configItems: [
        {
          key: 'total_order',
          label: 'Lượng hợp đồng duy trì',
          show: true
        }, {
          key: 'total_debt',
          label: 'Lượng công nợ cần thu',
          show: true
        }, {
          key: 'paid_amount',
          label: 'Thực thu',
          show: true,
          thClass: 'text-red',
        }, {
          key: 'paid_amount_percent',
          label: '% Thực thu',
          show: true
        }, {
          key: 'remaining_debt',
          label: 'Công nợ cộng dồn',
          show: true
        }, {
          key: 'waiting_approved_remaining_debt',
          label: 'Công nợ KT chưa duyệt cộng dồn',
          show: true
        }, {
          key: 'total_price',
          label: 'Đơn giá',
          show: true
        }
      ],
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      configSearchItems: [
        {
          key: 'init_date',
          label: 'Ngày khởi tạo',
          show: true
        }, {
          key: 'confirmed_date',
          label: 'Ngày chốt đơn',
          show: true
        }, {
          key: 'data_date',
          label: 'Ngày phát sinh doanh số',
          show: true
        }, {
          key: 'charge_date',
          label: 'Ngày tính phí',
          show: true
        }, {
          key: 'status',
          label: 'Trạng thái đơn hàng',
          show: true
        }, {
          key: 'data_source',
          label: 'Nguồn đơn',
          show: false
        }, {
          key: 'debt_status',
          label: 'Trạng thái nợ',
          show: false
        }, {
          key: 'pics',
          label: 'Nhân viên chăm sóc',
          show: false
        }, {
          key: 'products',
          label: 'Sản phẩm',
          show: false
        }
      ],
      items: [],
      users: [],
      groupUser: [],
      products: [],
      groupProduct: [],
      loadingUser: false,
      loadingProduct: false,
      debounceUser: null,
      selected: [],
      showConfigTable: false,
      showConfigSearch: false,
      isEditable: true,
      disablePic: false,
      selectedId: null
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)) {
      this.disablePic = true
      this.filterData.pics = [{code: this.userInfo.id, name: this.userInfo.username}]
    }
    this.initDataStatus()
    this.filterProduct()
    this.isEditable = this.hasEditPermission()
    const searchItems = localStorage.getItem(LOCAL_STORAGE_KEY.REPORT_ANNUAL_REVENUE_SEARCH_ITEMS)
    if (searchItems) {
      this.configSearchItems = JSON.parse(searchItems)
    }
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
    this.fields = this.originFields
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    callPhone (phoneNumber) {
      this.changePhoneNumber({phoneNumber: phoneNumber})
      this.$bvModal.show('phone-call-modal')
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)
    },
    initDataStatus () {
      Promise.all([this.getDataStatus(), this.getDataSubStatus(), this.getDataSource(), this.getDataChannel()]).then(([dataStatus, dataSubStatus, dataSource, dataChannel]) => {
        this.statusList = dataStatus.map(item => {
          const subStatus = dataSubStatus.filter(subItem => subItem.data_status === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_status: subItem.data_status}
          })
          return {value: item.id, text: item.name, details: subStatus}
        })

        this.data_source = dataSource.map(item => {
          const subList = dataChannel.filter(subItem => subItem.data_source === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_source: subItem.data_source}
          })
          return {value: item.id, text: item.name, details: subList}
        })
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    async getDataStatus () {
      const response = await DataStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSubStatus () {
      const response = await DataSubStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSource () {
      const response = await DataSourceAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    async getDataChannel () {
      const response = await DataChannelAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.users.unshift({
          'name': 'Chưa chia data',
          'code': null
        })

        if (!this.disablePic) {
          this.filterData.pics = this.users
        }

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.filter()
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    filterProduct () {
      this.loadingProduct = true
      ProductApi.filter({
        name: '',
        payment_method: 'CREDIT',
        company_id: this.company.id
      }, 0, MAX_PRODUCT_NUMBER).then(res => {
        this.products = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.filterData.products = this.products
        this.groupProduct = [
          {
            label: 'Tất cả',
            products: this.products
          }
        ]
        this.filterUser('')
        this.loadingProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingProduct = false
      })
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      let filterData = this.buildFilterData()
      ReportAPI.filterAnnualOrderReport(filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total

        ReportAPI.filterAnnualOrderReport(filterData, 0, this.totalRow).then(res1 => {
          let totalItem = {
            pic: 'Tổng',
            total_order: 0,
            total_debt: 0,
            paid_amount: 0,
            paid_amount_percent: 0,
            remaining_debt: 0,
            waiting_approved_remaining_debt: 0,
            total_price: 0
          }
          let items = res1.data.data.records
          items.map(item => {
            totalItem.total_order += item.total_order
            totalItem.total_debt += item.total_debt
            totalItem.paid_amount += item.paid_amount
            totalItem.paid_amount_percent += item.paid_amount_percent
            totalItem.remaining_debt += item.remaining_debt
            totalItem.waiting_approved_remaining_debt += item.waiting_approved_remaining_debt
            totalItem.total_price += item.total_price
          })
          this.items.unshift(totalItem)
          this.loading = false
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    buildFilterOrderData () {
      const filter = {
        from_date: this.filterData.init_date[0],
        to_date: this.filterData.init_date[1],
        confirmed_from_date: this.filterData.confirmed_date[0],
        confirmed_to_date: this.filterData.confirmed_date[1],
        payment_from_date: this.filterData.data_date[0],
        payment_to_date: this.filterData.data_date[1],
        data_status: [],
        data_source: [],
        phone: this.filterData.phone,
        customer_name: this.filterData.customer_name,
        debt_status: null,
        pics: [],
        charge_from_date: this.filterData.charge_date[0] ? this.filterData.charge_date[0] + '-01' : this.filterData.charge_date[0],
        charge_to_date: this.filterData.charge_date[1] ? this.filterData.charge_date[1] + '-01' : this.filterData.charge_date[1],
      }
      if (this.filterData.statusDetail.length === 0) {
        filter.data_status = this.filterData.status.map(item => {
          return {data_status_id: item.value, data_sub_status_id: null}
        })
      } else {
        filter.data_status = this.filterData.statusDetail.map(item => {
          return {data_status_id: item.data_status, data_sub_status_id: item.value}
        })
      }
      if (this.filterData.data_channel.length === 0) {
        filter.data_source = this.filterData.data_source.map(item => {
          return {data_source_id: item.id, data_channel_id: null}
        })
      } else {
        filter.data_source = this.filterData.data_channel.map(item => {
          return {data_source_id: item.data_source, data_channel_id: item.value}
        })
      }
      if (this.filterData.pics.length > 0) {
        filter.pics = this.filterData.pics.map(item => item.code)
      }

      if (this.filterData.debt_status) {
        filter.debt_status = this.filterData.debt_status.value
      }
      if (filter.phone === '' || filter.phone === null) {
        delete filter['phone']
      }
      if (filter.customer_name === '' || filter.customer_name === null) {
        delete filter['customer_name']
      }
      if (filter.debt_status === '' || filter.debt_status === null) {
        delete filter['debt_status']
      }
      return filter
    },
    buildFilterProductData () {
      return this.filterData.products.map(item => item.code)
    },
    buildFilterData () {
      return {
        order: this.buildFilterOrderData(),
        product_id_list: this.buildFilterProductData(),
        order_by: 'desc'
      }
    },
    search () {
      this.filter()
    },
    add () {
      this.selectedId = null
      this.$bvModal.show('orderDetailModal')
    },
    hideModal (modalId) {
      this.$bvModal.hide(modalId)
    },
    detail (id) {
      this.selectedId = id
      this.$bvModal.show('orderDetailModal')
    },
    onSelectStatus (event, status) {
      this.statusDetailList.push(...event.details)
    },
    onRemoveStatus (event, status) {
      this.statusDetailList = this.statusDetailList.filter(item => item.data_status !== event.value)
      this.filterData.statusDetail = this.filterData.statusDetail.filter(item => item.data_status !== event.value)
    },
    onSelectStatusBulkUpdateData (event, status) {
      this.statusDetailList.push(...event.details)
      this.bulkUpdateData.statusDetail = null
    },
    onRemoveStatusBulkUpdateData (event, status) {
      this.statusDetailList = this.statusDetailList.filter(item => item.data_status !== event.value)
      this.bulkUpdateData.statusDetail = null
    },
    onSelectSource (event, status) {
      this.data_channel.push(...event.details)
    },
    onRemoveSource (event, status) {
      this.data_channel = this.data_channel.filter(item => item.data_source !== event.value)
      this.filterData.data_channel = this.filterData.data_channel.filter(item => item.data_source !== event.value)
    },
    check (event, id) {
      if (event) {
        this.selectedIds.push(id)
      } else {
        this.selectedIds = this.selectedIds.filter(item => item !== id)
      }
    },
    toggleColumn (event, key) {
      this.originFields = this.originFields.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)
    },
    onRowSelected (items) {
      this.selected = items
    },
    onCheckAll (event) {
      if (this.checkAll === 'check_all') {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    bulkUpdate () {
      if (this.selected.length > 0) {
        this.$bvModal.show('bulkUpdateModal')
      }
    },
    splitForSale () {
      if (this.selected.length > 0) {
        this.$bvModal.show('splitForSaleModal')
      }
    },
    remove (id) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            ReportAPI.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })

      localStorage.setItem(LOCAL_STORAGE_KEY.REPORT_ANNUAL_REVENUE_SEARCH_ITEMS, JSON.stringify(this.configSearchItems))
    },
    toggleRow (row) {
      if (row.rowSelected) {
        this.$refs.selectableTable.selectRow(row.index)
      } else {
        this.$refs.selectableTable.unselectRow(row.index)
      }
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/report/ReportAnnualRevenue.vue